import React from 'react';
import {
  Container,
  makeStyles
} from '@material-ui/core';
import Page from 'src/components/Page';
import ShowAlert from 'src/screens/alerts/ShowAlert';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  productCard: {
    height: '100%'
  }
}));

const Alerts = () => {
  const classes = useStyles();

  return (
    <Page
      className={classes.root}
      title="Alert"
    >
      <Container maxWidth={false}>
        <ShowAlert />
      </Container>
    </Page>
  );
};

export default Alerts;
